<template>
    <div class="bxs-textarea-field">
        <!-- <label
        ref="label"
        :for="name">{{ required ? '* ' + label : label }}</label> -->

        <textarea
        v-model="local_value"
        ref="input"
        :name="name"
        :id="id || name"
        :placeholder="label"
        cols="30"
        rows="10"></textarea>
    </div>
</template>

<script>
import {
    onMounted,
    onBeforeUnmount,
    inject,
    getCurrentInstance
} from 'vue'

export default {
    name: 'bxs-textarea-field',
    props: {
        modelValue: {
            type: [String, Number],
            required: false,
            default: null
        },
        rules: {
            type: Array,
            required: false,
            default: () => []
        },
        required: {
            type: Boolean,
            required: false,
            default: false
        },
        placeholder: {
            type: String,
            required: false,
            default: null
        },
        label: {
            type: String,
            required: false,
            default: null
        },
        name: {
            type: String,
            required: true
        },
        id: {
            type: String,
            required: false,
            default: null
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        solo: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'update:modelValue',
        'change'
    ],
    setup (props, ctx) {
        // console.log('ctx', ctx)
        const instance = getCurrentInstance()
        // console.log('instance', instance)

        if (!props.solo) {
            const form = inject('bxs-form')
            // console.log(props.name, ' bxs-form', form)
            const uid = instance.uid

            onMounted(() => {
                if (form) {
                    form.bind({
                        validate: instance.ctx.validate,
                        getValue: instance.ctx.getValue,
                        reset: instance.ctx.reset,
                        resetValidation: instance.ctx.resetValidation,
                        name: props.name,
                        uid
                    })
                }
            })

            onBeforeUnmount(() => {
                if (form) {
                    form.unbind(uid)
                }
            })
        }
    },
    data () {
        return {
            local_value: this.modelValue,
            valid: true,
            cacheErrors: [],
            selected_rules: []
        }
    },
    watch: {
        local_value (newVal) {
            this.$emit('update:modelValue', newVal)
        }
    },
    methods: {
        reset () {
            this.local_value = null
            this.resetValidation()
            this.$emit('update:modelValue', this.local_value)
        },
        resetValidation () {
            this.cacheErrors = []
            this.valid = true
        },
        getValue () {
            return this.local_value
        },
        validate () {
            let v = true
            this.cacheErrors = []

            if (this.selected_rules.length > 0) {
                this.selected_rules.forEach((rule) => {
                    if (typeof rule === 'function') {
                        const resRule = rule(this.local_value)

                        if (typeof resRule === 'string') {
                            this.cacheErrors.push(resRule)
                        } else if (typeof resRule === 'boolean') {
                            v = resRule
                        } else {
                            console.error('error valid input =>', resRule)
                        }
                    }
                })

                v = this.cacheErrors.length === 0
            }

            this.valid = v

            return {
                value: v,
                errors: this.cacheErrors
            }
        }
    }
}
</script>

<style lang="scss" scoped>
$space: calc(0.15rem * var(--interaction-multi));

$input-height: var(--input-min-height);

$font-size-base: calc($input-height / 3);
$font-size-small: calc($input-height / 4);
$font-size-smallest: calc($font-size-small / 1.05);
$font-weight: normal;

$label-transition: 0.2s ease all;
$label-top: calc(50% - ($font-size-base / 2));
$label-top-raised: $space;

$input-padding-top: calc($label-top-raised * 2.5);

$hint-margin-top: 0.25rem;
$error-margin-top: 0.2rem;

$color-disabled: var(--color-disabled);
$color-input: var(--input-color);
$color-label: var(--color-disabled);
$color-placeholder: $color-disabled;
$color-hint: $color-disabled;
$color-focused: var(--color-primary);
$color-error: var(--color-error);

// Mixins:
@mixin label-slided-top() {
    // position: relative;
    top: $label-top-raised;
    font-size: $font-size-small;
}

.bxs-textarea-field {
    position: relative;
    user-select: none;
    // margin-bottom: var(--size-ui);
    border: none;
    text-align: left;

    > textarea {
        width: 100%;
        font-size: $font-size-base;
        font-family: var(--typo-family-ui);
        font-weight: var(--action-typo-weight);
        line-height: normal;
        color: $color-input;

        border-width: var(--thickness);
        border-style: solid;
        border-color: transparent;
        border-radius: var(--radius);
        background-color: var(--input-background-color);

        padding: 1rem;
    }
}
</style>